import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { COLORS } from '../utils/colors';
import { AuthContext } from '../reducers/Auth/AuthContext';

const ErrorPage = () => {
  const [, , { logout }] = useContext(AuthContext);

  // useEffect(() => {
  //   logout();
  // }, [])

  return (
    <Grid container justify="center">
      <Grid item xs={12} sm={3} />
      <Grid item xs={12} sm={6} style={{ textAlign: 'center' }}>
        <Typography
          component="h1"
          variant="h4"
          style={{ marginTop: '200px', padding: '15px', color: COLORS.INFO }}
        >
          COULD NOT GET DATA FROM THE SERVER
        </Typography>
        <Typography
          component="h1"
          variant="h5"
          style={{ marginTop: '100px', padding: '15px', color: COLORS.INFO }}
        >
          TRY TO LOGIN AGAIN IN FEW MINUTES
        </Typography>
        <Link to="/login" replace>
          <Button variant="contained" color="primary" style={{ marginTop: '60px' }}>
            GO TO LOGIN
          </Button>
        </Link>
      </Grid>
      <Grid item xs={12} sm={3} />
    </Grid>
  );
};

export default ErrorPage;
